import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Header,
  Form,
  Loader,
  Modal,
  Icon,
  Button,
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import { reportActions } from '../../actions/report.actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/pt-br';
import { PaginationContainer } from '../../components/PaginationContainer';
import _ from 'lodash';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class NotificationScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        page: 1,
        username: null,
        source: null,
        period: ''
    };
  }

  static get propTypes() {
    return {
       registers: PropTypes.any,
       loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchRegisters();
    }, 500);
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${today} - ${today}`}, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
      this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period }, () => this.fetchRegisters());
  }

  handleUsernameChange(username) {
    this.setState({ username, page: 1 });
    this.handleSearchDebounced();
  }

  handleTypeChange(type) {
    this.setState({ type, page: 1 });
    this.handleSearchDebounced();
  }

  handleChange(field, data) {    
    const { request } = this.state;    
    request[field] = data;    
    this.setState({ request });    
  }

  handleSubmit() {
    const { dispatch } = this.props;
    const { request } = this.state;
    let payload = {
      username: request.username,
      message: request.message,
    };

    dispatch(reportActions.createNotification(payload)).then(() => {
      this.fetchRegisters()
    });    
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { page, username, type, period } = this.state;

    var [startDate, endDate] = period.split(' - ');
    if (startDate) {
      startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    if (endDate) {
      endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    dispatch(reportActions.fetchNotifications({ page, username, type, startDate, endDate, orderBy: "Id", export: isExport ? true : null, ascending: false }));
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  render() {
    const { registers, loading } = this.props;
    const { period } = this.state;

    return (
      <Fragment>
        <Header>
          <h1>Notificações Enviadas</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group widths={4}>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Data'
              closable={true}
              clearable={true}              
              onChange={(e, data) => this.handlePeriodChange(data.value)}              
            />
            <Form.Input icon='search' label='Username' onChange={(e, data) => this.handleUsernameChange(data.value)} loading={loading} />
            <Form.Input icon='search' label='Tipo' onChange={(e, data) => this.handleTypeChange(data.value)} loading={loading} />                      
          </Form.Group>          
        </Form>

        {registers && registers.Results && registers.Results.length > 0 &&
          <Table compact>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Data</Table.HeaderCell>
                    <Table.HeaderCell>Tipo</Table.HeaderCell>
                    <Table.HeaderCell>Username</Table.HeaderCell>                    
                    <Table.HeaderCell>Mensagem</Table.HeaderCell>                    
                </Table.Row>
            </Table.Header>
            <Table.Body>
                { registers && registers.Results && registers.Results.map((register) => {
                    return <Table.Row key={register.Id}>                        
                        <Table.Cell>{moment(register.SentAt).format('DD/MM/YYYY HH:mm:ss')}</Table.Cell>
                        <Table.Cell>{register.Config.Type.Name}</Table.Cell>
                        <Table.Cell>{register.User.Username}</Table.Cell>                        
                        <Table.Cell>{register.Message}</Table.Cell>
                    </Table.Row>;
                }) }
            </Table.Body>
        </Table>}
        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { report } = state;    
  return {
     registers: report.notifications || null,
     loading: report.loading
  };
}

const connectedNotificationScreen = connect(mapStateToProps)(NotificationScreen);
export { connectedNotificationScreen as NotificationScreen };
